import React from 'react'
import Share from '@material-ui/icons/Share'

export default function ShareIcon(props) {
    const { ...other } = props

    return (
        <Share {...other} />
    )
}